import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var selectConnectedAccount = mutatorAction('selectConnectedAccount', function (index) {
    var store = connectedAccountsStore();
    store.selected = index;
});
//# sourceMappingURL=selectConnectedAccount.js.map